module.exports = __webpack_public_path__ + "static/problem-space-d8427cdef0e32ed49ce85d26058217a1.png";